import { api } from 'new/api/axios';
import { createEndpoint } from 'new/api/utils';
import {
  LeaderboardResult,
  LeaderboardUserResult,
  LeaderboardWinnersRequest,
  LeaderboardWinnersResult,
} from './types';

export const getLeaderboard = createEndpoint<LeaderboardResult, unknown>({
  url: 'leaderboard/interoffice',
  endpoint: ({ url }) => api.get(url),
});

export const getUserLeaderboard = createEndpoint<
  LeaderboardUserResult,
  unknown
>({
  url: 'leaderboard/interoffice/personal/:id',
  endpoint: ({ url }) => api.get(url),
});

export const getLeaderboardWinners = createEndpoint<
  LeaderboardWinnersResult,
  LeaderboardWinnersRequest
>({
  url: 'leaderboard/interoffice/winners',
  endpoint: ({ url, params }) => api.get(url, { params }),
});
